module.exports = __webpack_public_path__ + "img/2.b59697a1.png";